import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as submitButtonActions from '../../actions/submit/submitButtonActions';
import * as userActions from '../../actions/userActions';
import * as companyActions from '../../actions/companyActions';
import * as pendingPageActions from '../../actions/pendingPageActions';
import * as modalActions from '../../actions/common/modalActions';
import UsersForm from './UsersForm';
import FormDataFormatter from "../../services/FormDataFormatter";
import UserParamsFormatter from "../../services/user/UserParamsFormatter";
import { FormattedMessage, injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';
import UserFormSerializer from "../../services/user/UserFormSerializer";
import WithResolvedPromises from "../common/WithResolvedPromises";
import Placeholder from "../Placeholder";
import PlaceholderError from "../common/PlaceholderError";
import ResetFormModal from "../ResetFormModal";

class UsersFormContainer extends React.Component {

    constructor(props) {
        super(props);

        this.userId = props.match.params.id;
        this.actions = this.getRequiredActions();
    }

    isUpdate() {
        return !!this.props.match.params.id;
    }

    getRequiredActions() {
        let actions = [
            this.props.actions.loadCompanies('*'),
        ];

        if(this.isUpdate()) {
            actions.push(this.props.actions.getUser(this.userId));
        }

        return actions;
    }

    componentDidMount() {
        this.props.actions.resetUser();
    }

    submit(formFields) {
        this.props.actions.showSubmitButtonSpinner();
        let params = UserParamsFormatter.format(formFields);

        if (this.isUpdate()) {
            this.props.actions.updateUser(FormDataFormatter.getFormData(params), this.props.user.id)
                .then(() => {
                    this.props.actions.hideSubmitButtonSpinner();
                    this.redirect();
                }).catch(() =>
                this.props.actions.hideSubmitButtonSpinner());
        } else {
            this.props.actions.createUser(FormDataFormatter.getFormData(params), true)
                .then(() => {
                    this.props.actions.hideSubmitButtonSpinner();
                    this.redirect();
                }).catch(() =>
                this.props.actions.hideSubmitButtonSpinner());
        }
    }

    confirmReset() {
        this.props.actions.hideResetFormModal();
        this.redirect();
    }

    handleReset() {
        this.props.actions.showResetFormModal();
    }

    redirect() {
        this.props.history.push('/brugere');
    }

    render() {
        let {
            user,
            companies,
            isCurrentUser,
        } = this.props;

        return (
            <WithResolvedPromises preloaderComponent={Placeholder} promises={this.actions} errorComponent={PlaceholderError}>
            <div>
                <div className="row">
                    <div className="col-12">
                        <div className="card m-b-20">
                            <div className="card-block">
                                <h1>
                                    {
                                        this.isUpdate()
                                            ? this.props.intl.formatMessage(messages.usersEditUser)
                                            : this.props.intl.formatMessage(messages.usersCreateUser)

                                    }
                                </h1>
                                <UsersForm
                                    initialValues={user}
                                    companies={companies}
                                    isCurrentUser={isCurrentUser}
                                    onSubmit={this.submit.bind(this)}
                                    handleReset={this.handleReset.bind(this)}
                                    isUpdate={this.isUpdate()}
                                    enableReinitialize={true}
                                    keepDirtyOnReinitialize={true}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <ResetFormModal
                    modalTitle={this.props.intl.formatMessage(messages.resetModalTitle)}
                    modalContent={
                        <p>
                            <FormattedMessage
                                id="reset.modal.message"
                                defaultMessage="Are you sure, you want to cancel? All of your alterations will be lost."
                            />
                        </p>}
                    confirmText={this.props.intl.formatMessage(messages.buttonYes)}
                    closeText={this.props.intl.formatMessage(messages.buttonNo)}
                    handleConfirm={() => {this.confirmReset()}}
                />
            </div>
            </WithResolvedPromises>
        )
    }
}

function mapStateToProps(state, ownProps) {
    let companies = state.companies.data || [];
    companies.forEach(function (company) {
        if (!company.name) {
            company.name = this.props.intl.formatMessage(messages.noName);
        }
    });



    let user = UserFormSerializer.unserialize(state.someUser);

    return {
        user,
        isCurrentUser: +state.user.id === +user.id,
        companies: state.companies.data || [],
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            Object.assign(
                {},
                userActions,
                companyActions,
                pendingPageActions,
                submitButtonActions,
                modalActions
            ), dispatch
        )
    }
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(UsersFormContainer));



// WEBPACK FOOTER //
// ./web/src/components/users/UsersFormContainer.jsx